export var FIELD_META_PROP = 'data-__meta';


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/form/constants.js
// module id = 277
// module chunks = 0